import { BaseModel } from './base';

export interface PointDeService {
    title: string,
    address: string,
    googlMap: string | null,
    tel: string | null;
}

export interface AdditionnalAdresses {
    title: string,
    address: string;
}

export interface Franchise extends BaseModel {
    name: string;
    code: string | null;
    postalCodes: string[];
    email: string | null,
    contactName: string | null,
    address: string | null,
    tel: string | null,
    alias: string | null,
    defaultDescription: string | null,
    defaultTitle: string | null,
    regions: string[] | null;
    facebookUrl: string | null,
    googleMapUrl: string | null,
    color: string | null,
    pointsDeService: string | null,
    homeText: string | null;
}

export const newFranchise: Franchise = {
    id: 0,
    name: '',
    code: null,
    postalCodes: [],
    email: null,
    contactName: null,
    address: null,
    tel: null,
    alias: null,
    defaultDescription: null,
    defaultTitle: null,
    regions: null,
    facebookUrl: null,
    googleMapUrl: null,
    color: '#000000',
    pointsDeService: null,
    homeText: null
};
